import React from "react";

export default function BookMarkFilled(props) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="18.053" height="24.5" viewBox="0 0 18.053 24.5">
			<path
				d="M20.474,3H7.579A2.576,2.576,0,0,0,5.013,5.579L5,27.5l9.026-7.737L23.053,27.5V5.579A2.587,2.587,0,0,0,20.474,3Z"
				transform="translate(-5 -3)"
				fill="#83909b"
			/>
		</svg>
	);
}

export function BookMarkFilledLg() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="18" height="24.5" viewBox="0 0 18 24.5">
			<path
				d="M20.172,3H7.529A2.525,2.525,0,0,0,5.013,5.529L5,27.022l8.85-7.586,8.85,7.586V5.529A2.536,2.536,0,0,0,20.172,3Z"
				transform="translate(-5 -3)"
				fill="#83909b"
			/>
		</svg>
	);
}
